import FadeInSection from "./FadeInSection";
import TestimonialCard from "./TestimonialCard";

function Testimonials() {
	return (
		<div className="testimonials-container">
			<div className="container">
				<FadeInSection animationType="fade-right">
					<h2>Testimonials</h2>
					<hr />
					<div className="row mt-5 gy-4">
						<div className="col-lg-3 col-md-6">
							<TestimonialCard
								review={
									"I really enjoyed my first visit to Mane & Bare! I had my haircut booked with Larry. He was really efficient and generally very kind. He made the experience pleasant and enjoyable. I'm looking forward to trying my treatments here! It truly is a hidden gem and I'm glad we have such a high quality salon in the area!"
								}
								stars={5}
								name={"Tatjana"}
							/>
						</div>
						<div className="col-lg-3 col-md-6">
							<TestimonialCard
								review={
									"Mane and Bare is truly a hidden gem! Silvana has been my hairdresser for some time, and her talent, attention to detail, and warmth always leave me feeling my absolute best. She brings not only great skill but also a genuine passion for her craft."
								}
								stars={5}
								name={"Anabela"}
							/>
						</div>
						<div className="col-lg-3 col-md-6">
							<TestimonialCard
								review={
									"Wonderful inviting salon and staff! Great decor. Suzanne is an amazing stylist who spends the time to chat with you and see what works best for your hair. She is incredibly kind, patient and talented. Her hair washes/head massage THE BEST!"
								}
								stars={5}
								name={"Karen"}
							/>
						</div>
						<div className="col-lg-3 col-md-6">
							<TestimonialCard
								review={
									"Loved my experience at Mane and Bare. The space feels so calming and welcoming, and the products they use are the best. My stylist really listened to what I wanted and gave me great tips for keeping my hair and scalp healthy. I left feeling refreshed, relaxed, and with amazing hair. Definitely recommend if you’re looking for a salon with a more holistic vibe."
								}
								stars={5}
								name={"Cata"}
							/>
						</div>
					</div>
					<a
						href="https://www.google.com/maps/place/Mane+and+Bare+Hair+Skin+wellness/@43.5000572,-79.6636395,17z/data=!3m1!4b1!4m18!1m9!3m8!1s0x882b4335280f47ab:0x60b62f2092e87d9f!2sMane+and+Bare+Hair+Skin+wellness!8m2!3d43.5000533!4d-79.6610646!9m1!1b1!16s%2Fg%2F11yk9fmrgr!3m7!1s0x882b4335280f47ab:0x60b62f2092e87d9f!8m2!3d43.5000533!4d-79.6610646!9m1!1b1!16s%2Fg%2F11yk9fmrgr?entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoASAFQAw%3D%3D"
						target="_blank"
						rel="noreferrer"
					>
						<button className="mt-5">Leave a Review</button>
					</a>
				</FadeInSection>
			</div>
		</div>
	);
}

export default Testimonials;
